import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHelp = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1.25rem",
	height: "1.25rem",
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_647_14980)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M7.57505 7.50007C7.77097 6.94313 8.15768 6.4735 8.66668 6.17435C9.17568 5.87521 9.77413 5.76585 10.356 5.86567C10.9379 5.96548 11.4657 6.26801 11.846 6.71968C12.2262 7.17135 12.4343 7.74301 12.4334 8.33341C12.4334 10.0001 9.93339 10.8334 9.93339 10.8334M10.0001 14.1667H10.0084M1.66675 7.10237V12.8978C1.66675 13.1016 1.66675 13.2035 1.68977 13.2994C1.71019 13.3845 1.74386 13.4658 1.78955 13.5403C1.84108 13.6244 1.91315 13.6965 2.05727 13.8406L6.15956 17.9429C6.30368 18.087 6.37575 18.1591 6.45984 18.2106C6.5344 18.2563 6.61569 18.29 6.70072 18.3104C6.79663 18.3334 6.89854 18.3334 7.10237 18.3334H12.8978C13.1016 18.3334 13.2035 18.3334 13.2994 18.3104C13.3845 18.29 13.4658 18.2563 13.5403 18.2106C13.6244 18.1591 13.6965 18.087 13.8406 17.9429L17.9429 13.8406C18.087 13.6965 18.1591 13.6244 18.2106 13.5403C18.2563 13.4658 18.29 13.3845 18.3104 13.2994C18.3334 13.2035 18.3334 13.1016 18.3334 12.8978V7.10237C18.3334 6.89854 18.3334 6.79663 18.3104 6.70072C18.29 6.61569 18.2563 6.5344 18.2106 6.45984C18.1591 6.37575 18.087 6.30368 17.9429 6.15956L13.8406 2.05727C13.6965 1.91315 13.6244 1.84108 13.5403 1.78955C13.4658 1.74386 13.3845 1.71019 13.2994 1.68977C13.2035 1.66675 13.1016 1.66675 12.8978 1.66675H7.10237C6.89854 1.66675 6.79663 1.66675 6.70072 1.68977C6.61569 1.71019 6.5344 1.74386 6.45984 1.78955C6.37575 1.84108 6.30368 1.91315 6.15956 2.05727L2.05727 6.15956C1.91315 6.30368 1.84108 6.37575 1.78955 6.45984C1.74386 6.5344 1.71019 6.61569 1.68977 6.70072C1.66675 6.79663 1.66675 6.89854 1.66675 7.10237Z",
			stroke: "#697586",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_647_14980",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "#697586"
		})
	}) })]
});
export default SvgHelp;
